module.exports = __webpack_public_path__ + "static/assets/d18c13e9e2a3b27f18dc21a438e6661c.svg";